import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Profile {
  id: number;
  username: string;
  name: string;
  role: string;
  profile_picture_url?: string;
  created_at: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getProfile(): Observable<Profile> {
    return this.http.get<Profile>(`${this.apiUrl}/profile`);
  }

  updateProfile(name: string): Observable<{ message: string; user: Profile }> {
    return this.http.put<{ message: string; user: Profile }>(`${this.apiUrl}/profile`, { name });
  }

  uploadProfilePicture(file: File): Observable<{ message: string; user: Profile; profile_picture_url: string }> {
    const formData = new FormData();
    formData.append('profile_picture', file);
    return this.http.post<{ message: string; user: Profile; profile_picture_url: string }>(
      `${this.apiUrl}/profile/picture`,
      formData
    );
  }

  getProfilePictureUrl(relativeUrl?: string): string {
    if (!relativeUrl) {
      return '';
    }
    // If it's already a full URL, return as is
    if (relativeUrl.startsWith('http')) {
      return relativeUrl;
    }
    // If it starts with /api, return as is (already correct)
    if (relativeUrl.startsWith('/api')) {
      return `${environment.apiUrl.replace('/api', '')}${relativeUrl}`;
    }
    // Otherwise, prepend the API URL
    return `${environment.apiUrl.replace('/api', '')}/api${relativeUrl}`;
  }
}

